import type { Channel, ChannelSort, MessageResponse, StreamChat } from 'stream-chat';
import { setSearchMessage } from './searchMessageMap';

export const getChannelsSort = (unreadOnly: boolean): ChannelSort => {
  return {
    // ...(!isFullAccessView && { pinned_at: -1 }),
    ...(unreadOnly && { has_unread: -1 }),
    last_message_at: -1,
  };
};

export const resolveMessageSearchResults = async (
  results: { message: MessageResponse }[],
  client: StreamChat,
): Promise<Channel[]> => {
  const tasks = results.map(async ({ message }) => {
    const { cid } = message;
    if (!cid) return null;

    const [type, id] = cid.split(':');
    const channel = client.channel(type, id);
    if (!channel.initialized) {
      await channel.watch();
    }

    const wrapper = Object.create(channel) as Channel;
    setSearchMessage(wrapper, message);
    return wrapper;
  });

  return (await Promise.all(tasks)).filter(Boolean) as Channel[];
};

export const getChatMembersCount = (channel?: Channel) => {
  if (!channel) return { onlineCount: 0, totalCount: 0 };

  const members = Object.values(channel.state.members);

  const onlineVisible = members.filter((m) => m.user?.online);

  return {
    onlineCount: onlineVisible.length,
    totalCount: members.length,
  };
};
